import classnames from 'classnames'
import React from 'react'
import { toPairs, pick } from 'ramda'

import enhancers from './enhancers'
import Element from './Element'

export function Part({ active, onActivate, onInput, part, theme, editable }) {
  const elements = pick(['evidence', 'reasoning', 'counterargument'])
  const classNames = classnames(theme.part, { [theme.active]: active })

  return (
    <div className={classNames} onClick={onActivate}>
      {toPairs(elements(part)).map(([type, value], index) =>
        <Element
            active={active}
            editable={editable}
            first={index === 0}
            key={index}
            type={type}
            value={value}
            onInput={onInput} />
      )}
    </div>
  )
}

export default enhancers(Part)



// WEBPACK FOOTER //
// ./client/modules/debate/components/Part/index.js